"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _q = _interopRequireDefault(require("q"));

var _I18nContext = _interopRequireDefault(require("../context/I18nContext"));

var withTranslations = function withTranslations(translations) {
  return function (WrappedComponent) {
    return function (_ref) {
      var props = (0, _extends2.default)({}, _ref);
      var I18nProvider = (0, _react.useContext)(_I18nContext.default);

      var _useState = (0, _react.useState)(false),
          _useState2 = (0, _slicedToArray2.default)(_useState, 2),
          langLoaded = _useState2[0],
          setLangLoaded = _useState2[1];

      (0, _react.useEffect)(function () {
        var langAvailable = _q.default.Promise.all((0, _toConsumableArray2.default)(translations.map(function (file) {
          return I18nProvider.register(file);
        })));

        langAvailable.then(function () {
          setLangLoaded(true);
        });
      }, [setLangLoaded, I18nProvider]);
      return !langLoaded ? null : _react.default.createElement(WrappedComponent, props);
    };
  };
};

var _default = withTranslations;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/decorators/withTranslations.js
// module id = 612
// module chunks = 209 210 211 212